import axios from "axios";
import { useEffect, useState } from "react";
import Footer from "../components/Footer";
import Startbar from "../components/Startbar";
import Topbar from "../components/Topbar";
import { BASE_URL } from '../config';

const ProfileUpdate = () => {
  const [refreshKey, setRefreshKey] = useState(0);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    password: "",
    profile_image: null,
  });
  const [imagePreview, setImagePreview] = useState(null);

  // 🔸 Fetch profile data when page loads
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${BASE_URL}/profile`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (response.status === 200 && response.data) {
          const user = response.data.user;

          setFormData({
            name: user.name || "",
            email: user.email || "",
            phone: user.phone || "",
            address: user.address || "",
            password: "",
            profile_image: null,
          });

          if (user.image) {
            setImagePreview(`https://api.softmri.com/storage/${user.image}`);
          }
        } else {
          console.error("Failed to load profile data");
        }

      } catch (error) {
        console.error("Error loading profile:", error);
      }
    };

    fetchProfile();
  }, [refreshKey]);

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === "file") {
      const file = files[0];
      setFormData((prev) => ({ ...prev, profile_image: file }));
      setImagePreview(URL.createObjectURL(file)); // for preview
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    data.append("name", formData.name);
    data.append("email", formData.email);
    data.append("phone", formData.phone);
    data.append("address", formData.address);
    data.append("password", formData.password);
    if (formData.profile_image) {
      data.append("profile_image", formData.profile_image);
    }

    try {
      const token = localStorage.getItem("token");

      const response = await axios.post(`${BASE_URL}/update-profile`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        alert("Profile updated successfully!");
        setRefreshKey((prev) => prev + 1); // refresh data
      } else {
        alert("Failed to update profile.");
      }

    } catch (error) {
      console.error("Error updating profile:", error);
      alert("An error occurred while updating profile.");
    }
  };

  return (
    <>
      <Topbar />
      <Startbar />
      <div className="page-wrapper">
        <div className="page-content">
          <div className="container-xxl">
            <div className="row justify-content-center">
              <div className="col-md-8 col-lg-6">
                <div className="card shadow-sm rounded-lg">
                  <div className="card-body p-4">
                    <h4 className="mb-4 text-center text-primary">Update Profile</h4>
                    <form onSubmit={handleSubmit} encType="multipart/form-data">
                      {/* Image Upload with Preview */}
                      <div className="mb-3 text-center">
                        {imagePreview ? (
                          <img
                            src={imagePreview}
                            alt="Profile Preview"
                            className="rounded-circle mb-3"
                            style={{ width: "120px", height: "120px", objectFit: "cover" }}
                          />
                        ) : (
                          <div className="mb-3 text-muted">No profile image selected</div>
                        )}
                        <input
                          type="file"
                          name="profile_image"
                          accept="image/*"
                          onChange={handleChange}
                          className="form-control"
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Full Name</label>
                        <input
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          className="form-control"
                          placeholder="Enter your name"
                          required
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Email</label>
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          className="form-control"
                          placeholder="Enter your email"
                          required
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Phone</label>
                        <input
                          type="text"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          className="form-control"
                          placeholder="Enter your phone number"
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Address</label>
                        <input
                          type="text"
                          name="address"
                          value={formData.address}
                          onChange={handleChange}
                          className="form-control"
                          placeholder="Enter your address"
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">New Password</label>
                        <input
                          type="password"
                          name="password"
                          value={formData.password}
                          onChange={handleChange}
                          className="form-control"
                          placeholder="Enter new password"
                        />
                      </div>

                      <div className="d-grid gap-2">
                        <button type="submit" className="btn btn-primary">
                          Save Changes
                        </button>
                        <button
                          type="button"
                          className="btn btn-secondary"
                          onClick={() => setRefreshKey((prev) => prev + 1)}
                        >
                          Reset
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default ProfileUpdate;
